import type { CardSourcesQueryResult, GetTeamCardSourcesQueryResultData } from '../../queries/paymentQuery';
import type { ZustandStore } from '../store.type';
import type { NamedSet } from 'zustand/middleware';

export type CardFeature = {
	isEnabled: boolean;
	name: string;
	label: string;
};

type TeamCardState = {
	teamCard: {
		cardFeatures: CardFeature[];
		areAllCardFeaturesDisabled: boolean;
		cardSourceOptions: CardSourcesQueryResult['data'];
	};
};

type TeamCardActions = {
	setTeamCardFeatures: (cardFeatures: Partial<TeamCardState['teamCard']['cardFeatures']>) => void;
	setTeamCardOptions: (cardSourceOptions: TeamCardState['teamCard']['cardSourceOptions']) => void;
};

export type TeamCardSlice = TeamCardState & TeamCardActions;

const teamCardInitialState: TeamCardState = {
	teamCard: {
		cardFeatures: [],
		areAllCardFeaturesDisabled: false,
		cardSourceOptions: [] as GetTeamCardSourcesQueryResultData[],
	},
};

export function teamCardSlice(set: NamedSet<ZustandStore>): TeamCardSlice {
	return {
		...teamCardInitialState,
		setTeamCardFeatures(cardFeatures: Partial<TeamCardState['teamCard']['cardFeatures']>): void {
			set(
				(state: TeamCardState) => {
					if (!cardFeatures || cardFeatures.length === 0) {
						return state;
					}
					state.teamCard.cardFeatures = cardFeatures as CardFeature[];
					if (cardFeatures.length > 0) {
						state.teamCard.areAllCardFeaturesDisabled = cardFeatures?.every(obj => {
							return !obj?.isEnabled;
						});
					}
					return state;
				},
				false,
				'[setTeamCardFeatures]',
			);
		},
		setTeamCardOptions(cardSourceOptions: TeamCardState['teamCard']['cardSourceOptions']): void {
			set(
				(state: TeamCardState) => {
					state.teamCard.cardSourceOptions = cardSourceOptions;
					return state;
				},
				false,
				'[setTeamCardOptions]',
			);
		},
	};
}
